import { render } from "./RemittancesView.vue?vue&type=template&id=ce327ec4"
import script from "./RemittancesView.vue?vue&type=script&lang=js"
export * from "./RemittancesView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__